import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface AgentCapabilitiesDetailsData {
  name: string,
  capabilities: any[]
}

@Component({
  selector: 'app-agent-capabilities-details',
  templateUrl: './agent-capabilities-details.component.html',
  styleUrls: ['./agent-capabilities-details.component.css']
})
export class AgentCapabilitiesDetailsComponent {

  constructor(
    public dialogRef: MatDialogRef<AgentCapabilitiesDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AgentCapabilitiesDetailsData) { }

  onClose(): void {
    this.dialogRef.close();
  }

}
